import { useState, useEffect } from "react";
import styles from "./CommingSoonProjects.module.css";
import { CommingSoonProjectAction } from "redux-container/comming-soon/CommingSoon";
import { LazyLoadImage } from "react-lazy-load-image-component";

import {
  CarouselProvider,
  Slider,
  Slide,
  Dot,
  ButtonBack,
  ButtonNext,
} from "pure-react-carousel";
import { useNavigate } from "react-router-dom";
import MediaAssets from "assets";
import { Typography } from "@mui/material";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";

import { useDispatch, useSelector } from "react-redux";
import { Constants } from "constants/Constants";
import EnqueryModal from "./EnqueryModal";
import MobileVersion from "./MobileVersion";
import EnqueryForm from "../enquery-form/EnqueryForm";

const actionDispatch = (dispatch: any) => {
  return {
    getCommingSoonProjectRequest: (params: any) =>
      dispatch(CommingSoonProjectAction.getCommingSoonProjectRequest(params)),
  };
};

const CommingSoonProjects = (prop: any) => {
  const { sliderData } = prop;

  const [upCommingProjects, setupCommingProjects] = useState<any>([]);
  const [openModal, setopenModal] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [projectName, setprojectName] = useState("");
  const [goaModal, setgoaModal] = useState(false);
  const { getCommingSoonProjectRequest } = actionDispatch(useDispatch());
  const navigate = useNavigate();

  const handleRiderct = (data: any) => {
    navigate(`/investment-details/${data.launchName.replace(/%20|\s/g, "-")}`, {
      state: {
        projectId: data.id,
        area: data?.areaStartingFrom,
        cost: data.priceStartingFrom,
        title: data.launchName,
        location: data.address.city,
        description: data.shortDescription,
        isDetailed: data.isSoldOut,
        isExplore: data.isSoldOut,
        isSold: data.isSoldOut,
        dataAsObject: data,
      },
    });
  };

  const projectDetails = useSelector((state: any) => {
    return state?.preLoginPageManagement?.investmentDetails
      ?.pageManagementsOrCollectionTwoModels;
  });

  const fethcingUpCoomingProjects = async () => {
    const res = await fetch(
      `${Constants.PRODUCTION_BASE_URL}hoabl-admin/project-contents-comingsoon`,
      {
        method: "GET",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    let result = await res.json();
    setupCommingProjects(result.data);
  };

  useEffect(() => {
    fethcingUpCoomingProjects();
  }, []);

  const arr = upCommingProjects?.filter((data: any, ind: any) => {
    return data.status == "1001";
  });
  if (!(arr?.length > 0)) {
    return <></>;
  }
  return (
    <>
      <div className={styles.forDesktop}>
        {prop.showHeader && (
          <div className={styles.top_div_style}>
            <div className={styles.slider_icon_style}>
              {/* <img src={MediaAssets.explore_icon} /> */}
            </div>
            <h4 className={styles.heading_style}>UPCOMING PROJECTS</h4>
            <div
              className={styles.slider_div_btn}
              style={{ background: "rgb(0,0,0,0.1)", color: "white" }}
              onClick={() => {
                navigate("/investments");
              }}
            >
              VIEW ALL PROJECTS
              <LazyLoadImage
                src={MediaAssets.arrow_left}
                style={{ marginLeft: "4px" }}
                alt="Landing page"
              />
            </div>
          </div>
        )}

        {openModal && <EnqueryForm setAyodhya={true} />}

        <div>
          <div className={styles.sliderCon}>
            <CarouselProvider
              naturalSlideWidth={100}
              naturalSlideHeight={54}
              totalSlides={arr?.length}
              // infinite={arr?.length >1 ? true:false}
              // isPlaying={true}
              interval={10000}
              visibleSlides={1.3}
            >
              <Slider>
                {arr &&
                  arr?.map((data: any, index: any) => {
                    return (
                      <Slide
                        key={index}
                        index={index}
                        onClick={() => {
                          if (index === 0) {
                            navigate("/ayodhya");
                          } else {
                            navigate("/goa");
                          }
                        }}
                        style={{ cursor: "pointer" }}
                      >
                        {/* <div className={styles.icon}>
                          <LazyLoadImage
                            className={styles.iconImg}
                            src={data?.projectIcon?.value?.url}
                          />
                        </div> */}
                        <div style={{ height: "100%" }}>
                          <LazyLoadImage
                            src={data?.bannerImage?.value?.url}
                            className={styles.feature_card_img_style}
                          />
                        </div>
                        <div className={styles.bottomDivStyle}>
                          <div className={styles.feature_card_content}>
                            <div>
                              <h2 className={styles.feature_card_h2_content}>
                                {data?.launchName}
                              </h2>
                              <h3 className={styles.feature_card_h3_content}>
                                {`${data?.address?.city} ${data?.address?.state}`}
                              </h3>
                            </div>
                            <div style={{ marginTop: "10px" }}>
                              <h4 className={styles.feature_card_h4_content}>
                                {data?.shortDescription}
                              </h4>
                            </div>
                          </div>
                          <div className={styles.areaPriceBtn}>
                            <div className={styles.active_btn}>
                              <LazyLoadImage
                                src={MediaAssets.edit_active_icon}
                                className={styles.edit_active_icon_style}
                              />
                              <div className={styles.active_content_position}>
                                <LazyLoadImage
                                  src={MediaAssets.Ic_button_world_icon}
                                  alt=""
                                  className={styles.worldIcon}
                                />
                                <Typography
                                  id={styles.active_content_explore}
                                  style={{
                                    fontFamily: "Futura Md BT",
                                    fontSize: "16px",
                                  }}
                                >
                                  Explore Now
                                </Typography>
                              </div>
                            </div>
                          </div>
                        </div>
                      </Slide>
                    );
                  })}
              </Slider>
              <div className={styles.controls}>
                {arr.length > 1 && (
                  <>
                    <ButtonBack className={styles.backBtn}>Back</ButtonBack>
                    <ButtonNext className={styles.nextBtn}>
                      <KeyboardArrowRightIcon className={styles.nextBtnIcon} />
                    </ButtonNext>
                  </>
                )}
              </div>
              <div className={styles.dot_wrapper}>
                {sliderData &&
                  sliderData?.map((data: any, index: any) => {
                    return (
                      <Dot
                        slide={index}
                        key={index}
                        className={styles.dot_style}
                      />
                    );
                  })}
              </div>
            </CarouselProvider>
          </div>
        </div>
      </div>
      <div className={styles.forMobile}>
        {prop.showHeader && (
          <div className={styles.top_div_style}>
            <div className={styles.slider_icon_style}></div>
            <h4 className={styles.heading_style}>UPCOMING PROJECTS</h4>
            <div
              className={styles.slider_div_btn}
              onClick={() => {
                navigate("/investments");
              }}
            >
              VIEW ALL PROJECTS
              <LazyLoadImage
                src={MediaAssets.arrow_left}
                style={{ marginLeft: "4px" }}
                alt="Landing page"
              />
            </div>
          </div>
        )}

        <MobileVersion
          sliderData={arr}
          modalOpen={modalOpen}
          setModalOpen={setModalOpen}
        />
      </div>
    </>
  );
};

export default CommingSoonProjects;
